const mediaQuery = window.matchMedia("(min-width: 1024px)");

function handleScreenChange(e) {
    if (e.matches) {
        return
    } else {
        const menuIcon = document.getElementById("menu-mobile-icon");
        const mobileMenu = document.getElementById("mobile-menu");
        const closeMenu = document.getElementById("close-menu");
        const overlay = document.getElementById("mobile-menu-overlay");

        function openMenu() {
            document.body.classList.add('overflow-hidden');
            mobileMenu.classList.remove("-translate-x-full");
            closeMenu.classList.remove("scale-0", "opacity-0");
            closeMenu.classList.add("scale-100", "opacity-100");
            overlay.classList.remove("invisible", "opacity-0");
            overlay.classList.add("opacity-100");
        }

        function closeMenuFunc() {
            document.body.classList.remove('overflow-hidden');
            mobileMenu.classList.add("-translate-x-full");
            closeMenu.classList.remove("scale-100", "opacity-100");
            closeMenu.classList.add("scale-0", "opacity-0");
            overlay.classList.remove("opacity-100");
            overlay.classList.add("opacity-0");
            setTimeout(() => {
                overlay.classList.add("invisible");
            }, 150);
        }

        if (menuIcon && mobileMenu && closeMenu && overlay) {
            menuIcon.addEventListener("click", openMenu);
            closeMenu.addEventListener("click", closeMenuFunc);
            overlay.addEventListener("click", closeMenuFunc);
        }
    }
}

mediaQuery.addEventListener("change", handleScreenChange);
handleScreenChange(mediaQuery);

function toggleMenu(button) {
    const submenu = button.nextElementSibling;
    const icon = button.querySelector('.menu-icon');

    document.querySelectorAll('.submenu').forEach((menu) => {
        const btn = menu.previousElementSibling;

        if (menu !== submenu) {
            menu.classList.add('hidden');
            btn.classList.remove('bg-b2c-gray-medium');

            const otherIcon = btn.querySelector('.menu-icon');
            if (otherIcon) {
                otherIcon.querySelector('.icon-plus')?.classList.remove('hidden');
                otherIcon.querySelector('.icon-minus')?.classList.add('hidden');
            }
        }
    });

    submenu.classList.toggle('hidden');

    if (submenu.classList.contains('hidden')) {
        button.classList.remove('bg-b2c-gray-medium');
        if (icon) {
            icon.querySelector('.icon-plus')?.classList.remove('hidden');
            icon.querySelector('.icon-minus')?.classList.add('hidden');
        }
    } else {
        button.classList.add('bg-b2c-gray-medium');
        if (icon) {
            icon.querySelector('.icon-plus')?.classList.add('hidden');
            icon.querySelector('.icon-minus')?.classList.remove('hidden');
        }
    }
}